var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRobot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7188 10.2812H10.2812C7.84775 10.2812 5.875 12.254 5.875 14.6875V35.25C5.875 37.6835 7.84775 39.6562 10.2812 39.6562H36.7188C39.1523 39.6562 41.125 37.6835 41.125 35.25V14.6875C41.125 12.254 39.1523 10.2812 36.7188 10.2812Z",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1094 26.4375H16.8906C14.8627 26.4375 13.2188 28.0815 13.2188 30.1094C13.2188 32.1373 14.8627 33.7812 16.8906 33.7812H30.1094C32.1373 33.7812 33.7812 32.1373 33.7812 30.1094C33.7812 28.0815 32.1373 26.4375 30.1094 26.4375Z",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1719 26.4375V33.7812",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8281 26.4375V33.7812",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 10.2812V2.9375",
    stroke: "#0FA958",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4219 22.0312C16.6386 22.0312 17.625 21.0449 17.625 19.8281C17.625 18.6114 16.6386 17.625 15.4219 17.625C14.2051 17.625 13.2188 18.6114 13.2188 19.8281C13.2188 21.0449 14.2051 22.0312 15.4219 22.0312Z",
    fill: "#0FA958"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5781 22.0312C32.7949 22.0312 33.7812 21.0449 33.7812 19.8281C33.7812 18.6114 32.7949 17.625 31.5781 17.625C30.3614 17.625 29.375 18.6114 29.375 19.8281C29.375 21.0449 30.3614 22.0312 31.5781 22.0312Z",
    fill: "#0FA958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobot);
export default __webpack_public_path__ + "static/media/Robot.87054d9d263c6cd312db940baccff116.svg";
export { ForwardRef as ReactComponent };